import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-[#1A1A1A] rounded-xl p-5 shadow-md mb-4" }
const _hoisted_2 = { class: "flex justify-between items-center mb-2" }
const _hoisted_3 = { class: "text-lg font-semibold text-[#C59C2F]" }
const _hoisted_4 = { class: "text-sm text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-500 italic"
}
const _hoisted_6 = {
  key: 1,
  class: "text-sm text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_7 = { class: "text-xs text-gray-400" }
const _hoisted_8 = { class: "text-sm text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "mt-3 border border-[#333] rounded-lg p-4 bg-black/30 text-white space-y-2 text-sm" }
const _hoisted_11 = { class: "opacity-70" }
const _hoisted_12 = { class: "text-right font-medium text-white" }

import { db } from '@/config/firebase';
import { formatFirebaseTimestamp } from '@/helpers';
import { Order, RequestStatus } from '@/types/order';
import { doc, getDoc } from 'firebase/firestore';

import {
  computed, onMounted, ref,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCard',
  props: {
    order: {}
  },
  setup(__props: any) {

const props = __props;

const user = ref<{ fullName: string; email: string } | null>(null);
const loadingUser = ref(true);

onMounted(async () => {
  try {
    const docRef = doc(db, 'users', props.order.userId);
    const snap = await getDoc(docRef);
    if (snap.exists()) {
      user.value = snap.data() as { fullName: string; email: string };
    }
  } catch (e) {
    console.error('Failed to fetch user info:', e);
  } finally {
    loadingUser.value = false;
  }
});

function formatKey(key: string) {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    .replace(/^./, (str) => str.toUpperCase());
}

const statusClass = computed(() => {
  switch (props.order.status) {
    case RequestStatus.Processing:
      return 'bg-yellow-100 text-yellow-800';
    case RequestStatus['In Progress']:
      return 'bg-blue-100 text-blue-800';
    case RequestStatus.Completed:
      return 'bg-green-100 text-green-800';
    case RequestStatus.Cancelled:
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-200 text-gray-800';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.order.title), 1),
      _createElementVNode("span", {
        class: _normalizeClass([statusClass.value, "text-xs font-semibold px-3 py-1 rounded-full capitalize"])
      }, _toDisplayString(_unref(RequestStatus)[_ctx.order.status]), 3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Price:", -1)),
      _createTextVNode(" £" + _toDisplayString(_ctx.order.payment?.amount?.toFixed(2)), 1)
    ]),
    (loadingUser.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Loading user info... "))
      : (user.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("strong", null, "User:", -1)),
            _createTextVNode(" " + _toDisplayString(user.value.fullName) + " ", 1),
            _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(user.value.email) + ")", 1)
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Created:", -1)),
      _createTextVNode(" " + _toDisplayString(_unref(formatFirebaseTimestamp)(_ctx.order.createdAt, true)), 1)
    ]),
    _createElementVNode("details", _hoisted_9, [
      _cache[3] || (_cache[3] = _createElementVNode("summary", { class: "text-[#C59C2F] cursor-pointer text-sm mb-1" }, " View Details ", -1)),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.inputData, (value, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "flex justify-between gap-4"
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(formatKey(key)), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(Array.isArray(value) ? value.join(", ") : value), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})